import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

interface CancelTransientStayDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  bookingNumber: string
  onConfirm: (params: { cancellation_reason?: string }) => void
  isPending: boolean
}

export function CancelTransientStayDialog({
  open,
  onOpenChange,
  bookingNumber,
  onConfirm,
  isPending,
}: CancelTransientStayDialogProps) {
  const [reason, setReason] = useState('')

  function handleConfirm() {
    onConfirm({ cancellation_reason: reason.trim() || undefined })
  }

  function handleOpenChange(next: boolean) {
    if (!next) setReason('')
    onOpenChange(next)
  }

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Booking</AlertDialogTitle>
          <AlertDialogDescription>
            Cancel booking{' '}
            <span className="font-mono font-semibold">{bookingNumber}</span>?
            This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="space-y-2 py-2">
          <Label htmlFor="cancel-reason">Reason (optional)</Label>
          <Textarea
            id="cancel-reason"
            placeholder="e.g. Client cancelled, weather delay…"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={2}
          />
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Keep Booking</AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? 'Cancelling…' : 'Cancel Booking'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
